import React from "react";
import { ItemType } from "../../../clients/graphqlTypes.js";
import type { AdditionalItemInput } from "../../trees-virtual/types.js";
import type { DocDataGrid_ItemFragment } from "./DocDataGrid.generated.js";
import { buildDocDataGridRows } from "./helpers.js";
import type { DocDataGridRow } from "./types.js";

export function useDocDataGridRows<T extends DocDataGrid_ItemFragment>(
  items: T[],
  rootItem: T | undefined,
  selectedItem: T | null,
  additionalItemInput: AdditionalItemInput | null | undefined,
  enableCreating: boolean,
  documentItemTypes: ItemType[],
  filterItem?: (item: T) => boolean,
  shouldRenderCreateInput?: (item: T) => boolean,
  showRootItem?: boolean
): DocDataGridRow<T>[] {
  return React.useMemo(
    () =>
      buildDocDataGridRows(
        items,
        rootItem,
        selectedItem,
        additionalItemInput,
        enableCreating,
        documentItemTypes,
        filterItem,
        shouldRenderCreateInput,
        showRootItem
      ),
    [
      items,
      rootItem,
      selectedItem,
      additionalItemInput,
      enableCreating,
      documentItemTypes,
      filterItem,
      shouldRenderCreateInput,
      showRootItem,
    ]
  );
}
